


























































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { store, CDR, StoreState, AppSettings } from "../../store";
import VueElementLoading from "vue-element-loading";
import { RotateSquare2 } from "vue-loading-spinner";
import { mapState } from "vuex";
import bulkimportcontact from "../Contact_sprint2/BulkImport_ContactSP2.vue";
import util from "../../lib/util";
import VueExcelXlsx from "vue-excel-xlsx";
import JsonCSV from "vue-json-csv";
import * as moment from "moment";

Vue.use(VueExcelXlsx);
Vue.component("downloadCsv", JsonCSV);

@Component({
  components: {
    RotateSquare2,
    VueElementLoading,
    bulkimportcontact,
  },
  computed: {
    ...mapState({
      devices: (state: StoreState) => (state.account as any).devices,
      SharedContact_count: (state: StoreState) =>   state.dashboard.SharedContact_count,
      PersonalContact_Count: (state: StoreState) => state.dashboard.PersonalContact_Count,
      PresenceContact_count: (state: StoreState) => state.dashboard.PresenceContact_count,
      FavoirteContact_Count: (state: StoreState) =>state.dashboard.FavoirteContact_Count,
      contactsidebar_status: (state: StoreState) =>state.dashboard.contactsidebar_status,
      tagstatus: (state: StoreState) => state.dashboard.Tag_status,
      handletagsidebar: (state: StoreState) => state.dashboard.handletagsidebar,
      PersonalContact_List: (state: StoreState) => state.dashboard.PersonalContact_List,
      SharedContact_List: (state: StoreState) => state.dashboard.SharedContact_List,
      FavoirteContact_List: (state: StoreState) =>state.dashboard.FavoirteContact_List,
      companyContact_List: (state: StoreState) =>state.dashboard.companyContact_List,
      Tag_list: (state: StoreState) => state.dashboard.Tag_list,
      Selectedcontact: (state: StoreState) => state.dashboard.selectedContact,
    }),
  },
   mounted: function() {
     console.log('TaGList in sidebar',(this as any).Tag_list);
     
   },

})
export default class ContactSidebar extends Vue {
  data() {
    return {
      filename: "ExportContact.csv",
      activebtn: "",
      tagsmodal: "",
      TAG_List: [],
      loading_tag: false,
      importmodal: false,
      isbulkimportmodal: false,      
      exceldata: [],
      personalcount: 0,
      sharedcount: 0,      
      isedittag: false,
      multipleselect: [],
      selected: [],
      selectAll: false,
      tagsort:[],
      tagactive:[],
      columns: [
        {
          value: "FIRST NAME",
          key: "FIRSTNAME",
        },
        {
          label: "LAST NAME",
          field: "LASTNAME",
        },
        {
          label: "MOBILE",
          field: "MOBILE",
        },
        {
          label: "WORK",
          field: "WORK",
        },
        {
          label: "HOME",
          field: "HOME",
        },
        {
          label: "COMPANY",
          field: "COMPANY",
        },
        {
          label: "ADDRESS",
          field: "ADDRESS",
        },
        {
          label: "EMAIL",
          field: "EMAIL",
        },
        {
          label: "TAGS",
          field: "TAGS",
        },
      ],
    };
  }

  @Watch("PersonalContact_List")
  onchangepersonalcontact() {
    this.$data.personalcount = 0;
    this.$data.personalcount = (this as any).PersonalContact_Count;
    (this as any).PersonalContact_List.length = this.$data.personalcount;
    this.$data.sharedcount = (this as any).SharedContact_count;
    (this as any).SharedContact_count = this.$data.sharedcount;
  }
  @Watch("FavoirteContact_List")
  change() {
    this.$data.personalcount = 0;
    this.$data.personalcount = (this as any).PersonalContact_Count;
    (this as any).PersonalContact_List.length = this.$data.personalcount;
  }
  @Watch("handletagsidebar")
  tagstatuschanged() {
    // this.$data.loading_tag=true;
    //this.gettaglist();
    console.log('herein tagg');
    this.gettaglist(util.handletag());
  }
  created() {
    this.$data.contacts = [];
    this.$store.dispatch("getContacts");
    this.gettaglist();
    this.$data.personalcount = 0;
    this.$data.personalcount = (this as any).PersonalContact_Count;
    (this as any).PersonalContact_List.length = this.$data.personalcount;
    this.$data.sharedcount = (this as any).SharedContact_count;
    (this as any).SharedContact_count = this.$data.sharedcount;
  }
   
   removeSelectedTag() {

   }

  sortingtags(tagname , sel) {
   
  if(this.$data.tagsort.indexOf(tagname._id) > -1){ 
      this.$data.tagsort.splice(this.$data.tagsort.indexOf(tagname._id),1);
      let ele = document.getElementById(tagname._id);
      ele.classList.remove('istagactivebg'); 
       let ele1 = document.getElementById(tagname._id + 'tagicon');
      ele1.classList.remove('istagiconinactive')
  }
  else{
    this.$data.tagsort.push(tagname._id); 
    let ele = document.getElementById(tagname._id);
      ele.classList.add('istagactivebg');
      let ele1 = document.getElementById(tagname._id + 'tagicon');
      ele1.classList.add('istagiconinactive')    
  }
  
  let uniqueChars = this.$data.tagsort.filter((c, index) => {
    return this.$data.tagsort.indexOf(c) === index;
  });
    this.$data.tagsort=uniqueChars;
    let tags = (this as any).Tag_list;//=util.handletag();
    console.log('tag list',tags);
    let tindex = tags.map(e=>e._id).indexOf(tagname._id);  
    let temp_count = sel? false : true;
    tags[tindex].select=temp_count;
     this.$store.commit("CONTACT_SIDEBARSTATSU", "all");
     this.$store.commit("SET_TAG_NAME", this.$data.tagsort);
     console.log('this.$data.tagsort',this.$data.tagsort);
     //this.$store.commit("CONTACT_SIDEBARSTATSU", tagname);
  }
  onclickedittag(tagname, i) {
    for (let i = 0; i < this.$data.TAG_List.length; i++) {
      if (tagname.tag == this.$data.TAG_List[i].tag) {
        var isedit = tagname.tag + "isedit";
        let ele = document.getElementById(tagname._id);
        ele.classList.add("edittagbgactive");
        if (ele.classList[2] == "clistactive") {
          ele.classList.remove("clistactive");
        }
      }
    }
  }
  onclickediticon(tagname, i) {
    var editiconclicked = tagname.tag + "iseditclicked";
    let e = document.getElementById(editiconclicked);
    e.classList.add("editicontest");
    this.onclickedittag(tagname, i);
  }
  onExport() {
    debugger;
    this.$data.exceldata = [];
    let taglist = [];
    var selectedcontact = (this as any).Selectedcontact;
    console.log('selectedcontact',selectedcontact);
    if (selectedcontact == null || selectedcontact.length == 0) {
      this.defaultContactExport((this as any).contactsidebar_status);
      return;
    }
    this.$data.multipleselect = [];
    this.$store.commit("CHANGE_SELECTED_CONTACT", this.$data.multipleselect);

    if (selectedcontact.length > 0) {
      for (var i = 0; i <= selectedcontact.length; i++) {
        taglist = [];
        
        console.log("here  selectedcontact", selectedcontact[i]);
        selectedcontact[i].select = false;
        this.$root.$emit("selectAlltablecheckbox", {
          selectcont: selectedcontact[i],
          type: selectedcontact[i].select,
        });
        var check = selectedcontact[i]._id;
        let ele = document.getElementById(check);
        ele.classList.remove("checkboxbg");
        debugger
        for (var j = 0; j < selectedcontact[i].tags1.length; j++) {
          
            taglist.push(selectedcontact[i].tags1[j].tag);
            selectedcontact[i].select = false;
          
        }
        if (typeof selectedcontact[i].address === "object") {
          selectedcontact[i].address = "";
        }
        if (selectedcontact[i].work != undefined) {
          var workarr = [];
          if (selectedcontact[i].work.length > 0) {
            var worknum = selectedcontact[i].work[0].work;
          } else {
            worknum = "";
          }
        } else {
          worknum = "";
        }
          if(selectedcontact[i].numbers.mobile.number){
          var phno = selectedcontact[i].numbers.mobile.number;
          if(phno.indexOf("+1") > -1) {
            phno = phno.toString().replace("+1", '');
           // selectedcontact[i].numbers.mobile.number = phno;
          }
          else{
           // phno =selectedcontact[i].numbers.mobile.number
          }
          
          }
        // for(var k=0;k< selectedcontact[i].work.length;k++)
        // {
        var contobject = {
          FIRSTNAME: selectedcontact[i].first_name,
          LASTNAME: selectedcontact[i].last_name,
          MOBILE: phno,
          HOME: selectedcontact[i].home,
          WORK: worknum,
          ADDRESS: selectedcontact[i].address,
          EMAIL: selectedcontact[i].email[0],
          COMPANY: selectedcontact[i].compny_name,
          TAGS: taglist.join(", "),
          //  }
          // }
        };

        this.$data.exceldata.push(contobject);
      }
    } else {
      for (var i = 0; i <= selectedcontact.length; i++) {
        console.log("there  selectedcontact", selectedcontact[i]);
        for (var j = 0; j < selectedcontact[i].tags1.length; j++) {
          taglist.push(selectedcontact[i].tags1[j].tag);
        }
        if (typeof selectedcontact[i].address === "object") {
          selectedcontact[i].address = "";
        }
        if (selectedcontact[i].work != undefined) {
          var workarr = [];
          if (selectedcontact[i].work.length > 0) {
            var worknum = selectedcontact[i].work[0].work;
          } else {
            worknum = "";
          }
           if(selectedcontact[i].numbers.mobile.number){
          var phno = selectedcontact[i].numbers.mobile.number;
          if(phno.indexOf("+1") > -1) {
            phno = phno.toString().replace("+1", '');
          }
         // selectedcontact[i].numbers.mobile.number = phno;
          }
          let contobject = {
            FIRSTNAME: selectedcontact.first_name,
            LASTNAME: selectedcontact.last_name,
            MOBILE: phno,
            HOME: selectedcontact.home,
            WORK: selectedcontact.work[0].work,
            ADDRESS: selectedcontact.address,
            EMAIL: selectedcontact.email[0],
            COMPANY: selectedcontact.compny_name,
            TAGS: taglist.join(", "),
          };
          this.$data.exceldata.push(contobject);
        }
      }
    }
    this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
  }
  defaultContactExport(sidebarstatus) {
    var contactlist = [];
    var contactsharedlist = [];
    var taglist = [];
    if (sidebarstatus == "personal") {
      contactlist = (this as any).PersonalContact_List;
      contactlist =this.Sortlist((this as any).PersonalContact_List);
    }
    if (sidebarstatus == "shared") {
      contactsharedlist = (this as any).SharedContact_List;
      contactlist = contactsharedlist;
    }
    if (sidebarstatus == "favorites") {
      contactlist = (this as any).FavoirteContact_List;
    }
    if (sidebarstatus == "company") {
      contactlist = (this as any).companyContact_List;
    }
    for (var i = 0; i < contactlist.length; i++) {
      taglist = [];
      for (let k in contactlist) {
        this.$root.$emit("selectAlltablecheckbox", {
          selectcont: contactlist[k],
          type: true,
        });
      }
      //method to uncheck the checkbox after export
      setTimeout(
        
        function () {
         this.$root.$emit("UnselectAlltablecheckbox", {
          selectcont: contactlist,
          type: false,
          });
          
          // for (let j in contactlist) {
          //   contactlist[j].select = false;
          //   this.$data.multipleselect = [];
          //   this.$store.commit(
          //     "CHANGE_SELECTED_CONTACT",
          //     this.$data.multipleselect
          //   );
          //   if (contactlist[j].select == false) {
          //     var check = contactlist[j]._id;
          //     let ele = document.getElementById(check);
          //     ele.classList.remove("checkboxbg");
          //   } else {
          //     var check = contactlist[j]._id;
          //     let ele = document.getElementById(check);
          //     ele.classList.remove("checkboxbg");
          //   //  ele.classList.add("checkboxbg");
          //   }
         // }
        }.bind(this),
        2000
      );

      if (contactlist[i].select == false) {
        var check = contactlist[i]._id;
        let ele = document.getElementById(check);
        ele.classList.remove("checkboxbg");
      } else {
        var check = contactlist[i]._id;
        let ele = document.getElementById(check);
        ele.classList.add("checkboxbg");
      }

      for (var j = 0; j < contactlist[i].tags1.length; j++) {
        taglist.push(contactlist[i].tags1[j].tag);
        //contactlist[i].select = false;
      }
      if (typeof contactlist[i].address === "object") {
        contactlist[i].address = "";
      }
      if (contactlist[i].work != undefined) {
        var workarr = [];
        if (contactlist[i].work.length > 0) {
          var worknum = contactlist[i].work[0].work;
        } else {
          worknum = "";
        }
      } else {
        worknum = "";
      }
      if(contactlist[i].numbers.mobile.number){
         var phno = contactlist[i].numbers.mobile.number;
      if(phno.indexOf("+1") > -1) {
        phno = phno.toString().replace("+1", '');
      }
     
      }
      // for(var k=0;k< selectedcontact[i].work.length;k++)
      // {
      var contobject = {
        FIRSTNAME: contactlist[i].first_name,
        LASTNAME: contactlist[i].last_name,
        MOBILE: phno,
        HOME: contactlist[i].home,
        WORK: worknum,
        ADDRESS: contactlist[i].address,
        EMAIL: contactlist[i].email[0],
        COMPANY: contactlist[i].compny_name,
        TAGS: taglist.join(", "),
        //  }
        // }
      };
      this.$data.exceldata.push(contobject);
    }
  }
  Sortlist(data){
  data.sort(function(a, b) { 
    const nameA = a.first_name.toLowerCase().trim(),
      nameB = b.first_name.toLowerCase().trim();
    if (nameA < nameB){
      //sort string ascending
      return -1;
      return 0;
    }
  });
   return data;
  }
  onImportModal() {
    debugger;
    this.$data.importmodal = true;
    let ele = document.getElementById("bulkimport");
    ele.classList.add("importbgactive");
    this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
    console.log('opening modal');
    this.$data.isbulkimportmodal = true;
    console.log('bulkimportmodal',this.$data.isbulkimportmodal);
    this.$data.contact_status = "";
    //this.mouseLeave_2();
  }

  mouseLeave_2() {
    var d = document.getElementById("yourDivId_2");
    d.style.visibility = "hidden";
  }
  bulkimportevent(value: any,error:any=false) { console.log('error',error);
    if(value=='refresh'){this.$emit("frombulkimprt", "refresh_listdata", "");}
    if(!error)
      this.$data.isbulkimportmodal = false;
  }
  getiutlooh() {
    this.$store.dispatch("getUserId").then((res) => {
      let redirectUrl = AppSettings.API_HOST + "outlookContactImport?user=" + res.data;
      window.location.href = redirectUrl;
    });
  }

  gettaglist(oldtag = []) { console.log('old tag',oldtag);
    if (oldtag.length == 0) {
      this.$store.dispatch("gettag").then((r) => {
          this.$data.loading_tag = false;
          let taglist = [];
          if (oldtag.length > 0) {
            //contact_count
            for (let i = 0; i < r.data.docs.length; i++) {
              if (oldtag.map((e) => e._id).indexOf(r.data.docs[i]._id) > -1)
                r.data.docs[i].contact_count =
                  oldtag[
                    oldtag.map((e) => e._id).indexOf(r.data.docs[i]._id)
                  ].contact_count;
              else r.data.docs[i].contact_count = 0;
              taglist.push(r.data.docs[i]);
            }
          } else {
            taglist = r.data.docs;
          }
          if (util.handletag().length == 0) util.handletag(taglist, "set");
          // util.handletag(r.data.docs, 'set');
          this.$data.TAG_List = [];
          this.$data.TAG_List = util.handletag();
          // this.$data.tagshow = false;
          //this.$data.tagshow = true;
        })
        .catch((err) => {
          this.$data.loading_tag = false;
          console.log(err);
        });
    } else {
      this.$data.TAG_List = [];
      this.$data.TAG_List = oldtag;
    }
  }

  butonAction(action) {
    if(action!='all') {
       let tags = (this as any).Tag_list;
       console.log('(this as any).Tag_list',(this as any).Tag_list);
        (this as any).Tag_list.forEach(( taginfo,i) => {
          (this as any).Tag_list[i].select=false;
          let ele = document.getElementById(taginfo._id);
          if (typeof(ele) != 'undefined' && ele != null)
          {
             ele.classList.remove('istagactivebg'); 
          }
          let ele1 = document.getElementById(taginfo._id + 'tagicon');
            if (typeof(ele1) != 'undefined' && ele1 != null) {
            ele1.classList.remove('istagiconinactive')
           }
          
          
      }); 
      this.$data.tagsort = [];
    }
    switch (action) {
      case "company":
        this.$store.commit("CONTACT_SIDEBARSTATSU", "company");
        break;
      case "shared":
        this.$store.commit("CONTACT_SIDEBARSTATSU", "shared");
        break;
      case "favorites":
        this.$store.commit("CONTACT_SIDEBARSTATSU", "favorites");
        break;
      case "personal":
        this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
        break;
      case "all":
        this.$store.commit("CONTACT_SIDEBARSTATSU", "all");
        break;  
      default:
        this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
        break;
    }
  }

  Tab_events(type, data = "") {
    switch (type) {
      case "create":
        this.$emit("tabmanag", "create");
        break;
      case "edit":
        this.$emit("tabmanag", "edit");
        this.$store.commit("TAB_ACTION", data);
        break;
      case "delete":
        this.$emit("tabmanag", "delete");
        this.$store.commit("TAB_ACTION", data);
        break;
      default:
        break;
    }
    this.$store.commit("TAB_STATUS", true);
  }
}
